import React, { Component } from "react";
import actions from '../actions';
import { connect } from 'react-redux';
import ObjectUtils from '../../shared/utils/ObjectUtils';
import InterfacesPage from "../components/InterfacesPage";
import PropTypes from "prop-types";

class InterfacesPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            universalSearchField: "",
            searchFieldsValues: {
                interfaceIdentifier: {
                    value: ""
                },
                name: {
                    value: ""
                },
                dataType: {
                    value: ""
                },
                category: {
                    value: ""
                },
                historyConfiguration: {
                    value: ""
                },
                unitType: {
                    value: ""
                },
                entityId: {
                    value: ""
                },
                terminalId: {
                    value: ""
                }
            }
        }
    }

    componentDidMount() {
        const {
            terminalParentEntity,
            getCategoryList,
            getUnitTypeList,
            getEntityListForInterfacesOfTerminal
        } = this.props;

        getCategoryList();
        getUnitTypeList();
        getEntityListForInterfacesOfTerminal(terminalParentEntity.value);

        this.fetchData();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        const {
            searchFieldsValues,
            universalSearchField
        } = this.state;

        const {
            terminalId,
        } = this.props;

        searchFieldsValues.terminalId.value = terminalId ? terminalId : "";

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                { ...acc } : { ...acc, [keyValuePair[0]]: keyValuePair[1].value }
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchInterfaces({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    }

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    }

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    handleSearchClear = () => {
        this.setState({
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    }

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    }

    handleSortChanged = newSort => {
        const {
            table: {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc ? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    }

    handleAddButtonClicked = () => {
        const { terminalId } = this.props;
        this.props.history.push('/terminals/' + terminalId + '/interfaces/create');
    }

    handleRowClicked = interfaceInstance => {
        const { terminalId } = this.props;
        this.props.history.push('/terminals/' + terminalId + '/interfaces/' + interfaceInstance.id);
    }

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            suppressSearchForm,
            terminalId,
            externalPageSize,
            categoryList,
            unitTypeList,
            availableEntityList
        } = this.props;

        const definitePageSize = externalPageSize ? externalPageSize : pageSize;
        
        return (
            <InterfacesPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}
                handleAddButtonClicked={this.handleAddButtonClicked}

                data={data}
                sort={sort}
                totalElements={totalElements}
                pages={pages}
                currentPage={currentPage}
                pageSize={definitePageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}

                categoryList={categoryList}
                unitTypeList={unitTypeList}
                entityList={availableEntityList}
                suppressSearchForm={suppressSearchForm}

                terminalId={terminalId}
            />
        );
    }
}

const mapStateToProps = ({ interfacesReducer }) => {
    return {
        searchFieldsData: interfacesReducer.searchFieldsData,
        table: interfacesReducer.table,
        interfaceProfilesList: interfacesReducer.interfaceProfilesList,
        categoryList: interfacesReducer.categoryList,
        unitTypeList: interfacesReducer.unitTypeList,
        availableEntityList: interfacesReducer.dataOfSearchFields.availableEntities.data
    };
};

const mapDispatchToProps = {
    searchInterfaces: actions.searchInterfaces,
    getCategoryList: actions.getCategoryList,
    getUnitTypeList: actions.getUnitTypeList,
    getEntityListForInterfacesOfTerminal: actions.getEntityListForInterfacesOfTerminal,
}

InterfacesPageContainer.propTypes = {
    suppressSearchForm: PropTypes.bool,
    terminalId: PropTypes.number,
    externalPageSize: PropTypes.number,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InterfacesPageContainer);